import remote from "../../../../services/remote";
import {getPatientsSuccess, getPatientsFailure, addPatientSuccess, addPatientFailure, deletePatientFailure, deletePatientSuccess} from "./actions";
import {GET_PATIENTS_REQUEST, ADD_PATIENT_REQUEST, DELETE_PATIENT_REQUEST} from "./constants";
import {call, put, takeLatest} from "redux-saga/effects";
import SentryManager from "../../../../monitoring/Sentry";

function* getPatients (action) {
    try {
        const response = yield call(remote, {
            route: '/admin/patients/get-patients',
            method: 'post',
            body: JSON.stringify(action.data)
        });
        if (response.success) {
            yield put(getPatientsSuccess(response.data));
        } else {
            yield put(getPatientsFailure());
        }
    } catch (e) {
        console.error(e);
        SentryManager.captureException(e);
    }
}

function* addPatient (action) {
    try {
        const response = yield call(remote, {
            route: '/admin/patients/add-patient',
            method: 'post',
            body: JSON.stringify(action.data)
        });
        if (response.success) {
            yield put(addPatientSuccess(response.data));
        } else {
            yield put(addPatientFailure());
        }
    } catch (e) {
        console.error(e);
        SentryManager.captureException(e);
    }
}

function* deletePatient (action) {
    try {
        const response = yield call(remote, {
            route: '/admin/patients/delete-patient',
            method: 'delete',
            body: JSON.stringify(action.data)
        });
        if (response.success) {
            yield put(deletePatientSuccess(response.data));
        } else {
            yield put(deletePatientFailure(response));
        }
    } catch (e) {
        console.error(e);
        SentryManager.captureException(e);
    }
}

export default function* watchAdminPatients() {
    yield takeLatest(GET_PATIENTS_REQUEST , getPatients);
    yield takeLatest(ADD_PATIENT_REQUEST , addPatient);
    yield takeLatest(DELETE_PATIENT_REQUEST , deletePatient);
}



// WEBPACK FOOTER //
// ./src/containers/Layouts/Admin/Patients/saga.js